import { IScatterShapePlatePoint } from 'interfaces/i-pitch-performance';

const DIAMETER_PX = 15;
const RADIUS_PX = DIAMETER_PX / 2;
const TOOLTIP_RADIUS_PX = 10;

export const PlateTarget = ({
  cx,
  cy,
  opacity = 1,
  payload,
  onMouseEnter,
  onMouseLeave,
}: IScatterShapePlatePoint) => {
  if (cx === undefined || cy === undefined || !payload) {
    return null;
  }

  return (
    <g
      opacity={opacity}
      stroke={`rgb(${payload.strokeRgb})`}
      strokeWidth={1}
      fill="none"
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
    >
      <circle
        cx={cx}
        cy={cy}
        r={TOOLTIP_RADIUS_PX}
        fill="transparent"
        stroke="none"
        pointerEvents="all"
      />
      <line x1={cx - RADIUS_PX} y1={cy} x2={cx + RADIUS_PX} y2={cy} />
      <line x1={cx} y1={cy - RADIUS_PX} x2={cx} y2={cy + RADIUS_PX} />
    </g>
  );
};
